
export enum TrustLevels {
  UNTERGEORDNET = "UNTERGEORDNET",
  NIEDRIG ="EIDAS_NIEDRIG",
  SUBSTANZIELL = "EIDAS_SUBSTANZIELL",
  HOCH = "EIDAS_HOCH",
}

export enum TrustLevelPriority {
  UNTERGEORDNET = 1,
  NIEDRIG = 2,
  SUBSTANZIELL = 3,
  HOCH = 4,
}

